import { AUD_DESKTOP_CAT_PROFILING } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isExperimentActive } from '../../utils/experiments';

export function selectIsCatProfilingDesktopExperimentEnabled({ experiments }: IApplicationState) {
  return isExperimentActive(experiments, AUD_DESKTOP_CAT_PROFILING, 'B');
}
